import { render, staticRenderFns } from "./TeachActiveRank.vue?vue&type=template&id=18e016bd&scoped=true"
import script from "./TeachActiveRank.vue?vue&type=script&lang=js"
export * from "./TeachActiveRank.vue?vue&type=script&lang=js"
import style0 from "./TeachActiveRank.vue?vue&type=style&index=0&id=18e016bd&prod&lang=scss&scoped=true"
import style1 from "./TeachActiveRank.vue?vue&type=style&index=1&id=18e016bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e016bd",
  null
  
)

export default component.exports